import { alpha } from '@mui/system'
import { type Components } from '@mui/material/styles'
import type { Tokens, Theme } from '../augmentation'
import { type ComponentCreation } from './types'

export const createMuiLink = ({ palette, misc }: Pick<Tokens, 'palette' | 'misc'>): Components<Theme> =>
  ({
    MuiLink: {
      defaultProps: {
        color: 'dark',
        underline: 'always',
      },
      styleOverrides: {
        root: ({ ownerState }) =>
          /**
           * UX wants the underline to cover the external link part as well
           */
          ({
            textDecoration: 'none',
            borderBottom: `1px solid transparent`,

            ...misc.createFocusVisibleState({
              borderRadius: misc.borderRadius(),
              borderBottom: 'none',
              marginBottom: '1px',

              outline: misc.borderStyle('info.main', 3),
              outlineOffset: misc.borderSize(2),
              boxShadow: 'none',
            }),

            ...misc.createHoverOrActiveState({
              opacity: 0.8,
            }),
            variants: [
              {
                props: { color: 'dark' },
                style: {
                  ...(ownerState.underline === 'always'
                    ? {
                        borderBottom: `1px solid ${alpha(palette.dark.dark, 0.4)}`,
                      }
                    : {}),
                },
              },
              {
                props: { color: 'light' },
                style: {
                  color: palette.primary.light,
                  ...(ownerState.underline === 'always'
                    ? {
                        borderBottom: `1px solid ${alpha(palette.primary.light, 0.4)}`,
                      }
                    : {}),
                },
              },
              {
                props: { color: 'primary' },
                style: {
                  color: palette.components.link.contrast,
                  ...(ownerState.underline === 'always'
                    ? { borderBottom: `1px solid ${alpha(palette.components.link.contrast, 0.4)}` }
                    : {}),

                  ...misc.createHoverOrActiveState({
                    color: palette.primary.dark,
                    ...(ownerState.underline !== 'none'
                      ? {
                          borderBottomColor: palette.primary.dark,
                        }
                      : {}),
                  }),
                },
              },
            ],
          }),
      },
    },
  }) satisfies ComponentCreation
